import { Injectable } from 'angular2/core';
import { Response } from 'angular2/http';
import { Observable } from 'rxjs/Observable';

import { Resource } from '../api/resource.service';
import { Company } from './company.model';

@Injectable()
export class CompanyService {

  constructor(private resource: Resource) { }

  save(event: Company): Observable<Response> {
    return this.resource.save(event);
  }

  get(id: string): Observable<Response> {
    return this.resource.get(id);
  }

  delete(event: Company): Observable<Response> {
    return this.resource.delete(event);
  }

  list(): Observable<Response> {
    return this.resource.list();
  }

  listPublic() : Observable<Response> {
    return this.resource.http.noAuth().get('/pub/companies');
  }

  asCompanyList(obs: Observable<Response>): Observable<Company[]> {
    return obs.map(response => {
      let companies: Company[] = [];
      let rawList = response.json();
      if (!(rawList instanceof Array)){
        throw 'response should be a JSON array';
      }
      for (let company of rawList) {
        companies.push(new Company().fromJson(company));
      }
      return companies;
    });
  }

}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/company/company.service.ts
 **/